export default "__VITE_ASSET__DGyUskaK__"